export default {
    getContactListForSigningTasksRequest(loanBorrowers, nbos, loan) {
          let eConsentStatuses = [];

          loanBorrowers.forEach(borrower => {
              let isAccepted = false;
              let acceptedDate;
              let requestedDate = borrower.borrowerConsentRequestDate;

              if (requestedDate) {
                  if (borrower.type === 'borrower') {
                      acceptedDate = loan.regulationZ[`eSignConsentBorrowerDateAccepted${borrower.applicationIndex + 1}`];
                      isAccepted = acceptedDate ? true : false;
                  } else {
                      acceptedDate = loan.regulationZ[`eSignConsentCoBorrowerDateAccepted${borrower.applicationIndex + 1}`];
                      isAccepted = acceptedDate ? true : false;
                  }

                  eConsentStatuses.push({
                      borrowerName: borrower.name,
                      borrowerEmail: borrower.email,
                      isAccepted: isAccepted,
                      acceptedDate: acceptedDate,
                      requestedDate: requestedDate,
                      borrowerType: borrower.type
                  })
              }
          });

          //nbo record must have a vesting type (borrowerType) for some reason to register the accepted date, so ignore those without it or the tasks won't ever clear...
          nbos.filter(nbo => nbo.vestingType).forEach(nbo => {
              let isAccepted = false;
              let acceptedDate;
              let requestedDate = nbo.consentRequestDate;

              if (requestedDate) {
                  let loanNbo = loan.nonBorrowingOwners?.find(nbo => nbo.id === nbo.id);

                  if (loanNbo)
                      acceptedDate = loanNbo.eSignConsentNbocDateAccepted,
                      isAccepted = acceptedDate ? true : false;

                      eConsentStatuses.push({
                          borrowerName: nbo.name,
                          borrowerEmail: nbo.email,
                          isAccepted: isAccepted,
                          acceptedDate: acceptedDate,
                          requestedDate: requestedDate,
                          borrowerType: nbo.type,
                          vestingType: nbo.vestingType
                      })
                  }
          });

          return eConsentStatuses;
    },
    getLoanBorrowers(loan) {
        let borrowers = [];

        loan.applications.forEach((app, index) => {
            if (app.borrower.fullName) {
                borrowers.push({
                    name: app.borrower.fullName,
                    type: 'borrower',
                    email: app.borrower.emailAddressText,
                    homePhoneNumber: app.borrower.homePhoneNumber,
                    mobilePhone: app.borrower.mobilePhone,
                    addressStreetLine1: app.borrower.mailingAddress?.addressStreetLine1,
                    addressCity: app.borrower.mailingAddress?.addressCity,
                    addressState: app.borrower.mailingAddress?.addressState,
                    addressPostalCode: app.borrower.mailingAddress?.addressPostalCode,
                    applicationIndex: index,
                    borrowerConsentRequestDate: app.borrower.borrowerConsentRequestDate,
                    maritalStatus: app.borrower.maritalStatusType,
                    creditScore: app.borrower.middleCreditScore,
                    dependentCount: app.borrower.dependentCount,
                    rent: app.borrower.residences?.find(res => res.residencyType === 'Current')?.rent,
                    monthlyIncome: app.borrower.totalMonthlyIncomeAmount,
                    expanded: false
                });
            }

            if (app.coborrower.fullName) {
                borrowers.push({
                    name: app.coborrower.fullName,
                    type: 'coborrower',
                    email: app.coborrower.emailAddressText,
                    homePhoneNumber: app.coborrower.homePhoneNumber,
                    mobilePhone: app.coborrower.mobilePhone,
                    addressStreetLine1: app.coborrower.mailingAddress?.addressStreetLine1,
                    addressCity: app.coborrower.mailingAddress?.addressCity,
                    addressState: app.coborrower.mailingAddress?.addressState,
                    addressPostalCode: app.coborrower.mailingAddress?.addressPostalCode,
                    applicationIndex: index,
                    borrowerConsentRequestDate: app.coborrower.borrowerConsentRequestDate,
                    maritalStatus: app.coborrower.maritalStatusType,
                    creditScore: app.coborrower.middleCreditScore,
                    dependentCount: app.coborrower.dependentCount,
                    rent: app.coborrower.residences?.find(res => res.residencyType === 'Current')?.rent,
                    monthlyIncome: app.coborrower.totalMonthlyIncomeAmount,
                    expanded: false
                });
            }
        });

        return borrowers;
    },
    getLoanNBOs(loan) {
        let nbos = [];

        if (loan.nonBorrowingOwners?.length > 0) {
            loan.nonBorrowingOwners.forEach((nbo, index) => {
                nbos.push({
                    name: this.buildNBOFullName(nbo),
                    type: 'nbo',
                    email: nbo.email,
                    homePhoneNumber: nbo.homePhoneNumber,
                    mobilePhone: nbo.cellPhoneNumber,
                    consentRequestDate: nbo.eSignConsentNbocDateSent,
                    id: nbo.id,
                    vestingType: nbo.borrowerType
                })
            });
        }

        return nbos;
    },
    buildNBOFullName(nbo) {
        return [nbo.firstName, nbo.middleName, nbo.lastName, nbo.suffixName].filter(name => name).join(' ');
    },
    buildPropertyAddress(loan) {
        if ((!loan.property?.streetAddress && !loan.property?.addressLineText) || !loan.property?.city || !loan.property?.state || !loan.property.postalCode) {
            return 'TBD';
        }

        return `${loan.property.streetAddress ?? loan.property.addressLineText} ${loan.property.city}, ${loan.property.state} ${loan.property.postalCode}`;
    },
    propertyUnitTypeSelects: ['Apartment', 'Basement', 'Building', 'Condo', 'Department', 'Floor', 'Front', 'Hangar', 'Key', 'Lobby', 'Lot', 'Lower', 'Office', 'Penthouse', 
        'Pier', 'Rear', 'Room', 'Side', 'Space', 'Stop', 'Suite', 'Trailer', 'Unit', 'Upper'
    ],
    setLoanSessionData(loanData) {
        console.log(loanData)
        sessionStorage.setItem('loanborrower', loanData.applications[0].borrower.fullName);
        sessionStorage.setItem('loannumber', loanData.loanNumber);
        sessionStorage.setItem('selectedloan', loanData.id);
        sessionStorage.setItem('loanchannel', loanData.channel);
        sessionStorage.setItem('loanmilestones', JSON.stringify(loanData.milestones));
        sessionStorage.setItem('currentmilestone', loanData.milestoneCurrentName);
        sessionStorage.setItem('applicationid', loanData.applications[0].id);

        let applications = loanData.applications.map((application, index) => {
            return {
                application: index + 1,
                applicationId: application.id,
                borrowerPairId: application.borrowerPairId
            }
        });

        sessionStorage.setItem('applications', JSON.stringify(applications));

        sessionStorage.setItem('borrowercount', loanData.borrowerCount);
        sessionStorage.setItem('hasmi', loanData.proposedMortgageInsuranceAmount);
        sessionStorage.setItem('loanprogram', loanData.applications[0].ausTracking.underwritingRiskAssessType);
        sessionStorage.setItem('loantype', loanData.mortgageType);
        sessionStorage.setItem('purchaseprice', loanData.purchasePriceAmount);

        if (loanData.applications[0].vols) {
            sessionStorage.setItem('loanvols', JSON.stringify(loanData.applications[0].vols));
        }
        let excludeField = loanData.customFields.find(field => field.fieldName === "CX.LL.EXCLUDE");
        console.log('exclude field', excludeField)

        let suspendField = loanData.customFields.find(field => field.fieldName === "CX.UW.SUSPEND");
        sessionStorage.setItem('issuspended', suspendField?.value?.toString());

        let deniedField = loanData.customFields.find(field => field.fieldName === "CX.UWI.DENIEDCHECK");
        sessionStorage.setItem('isdenied', deniedField?.value?.toString());

        let loanSummary = {
            loanAmount: loanData.borrowerRequestedLoanAmount,
            loanPurpose: loanData.property?.loanPurposeType,
            dti: loanData.applications[0].bottomRatioPercent,
            ltv: loanData.ltv,
            interestRate: loanData.requestedInterestRatePercent,
            creditScore: loanData.creditScoreToUse,
            propertyType: loanData.loanProductData?.gsePropertyType,
            cityState: loanData.property?.state && loanData.property?.city
                ? `${loanData.property.state}, ${loanData.property.city}`
                : null
        }

        sessionStorage.setItem('loandata', JSON.stringify(loanSummary));

        let currentProcessor = loanData.contacts.find(contact => contact.contactType === 'LOAN_PROCESSOR');
        if (currentProcessor) {
            sessionStorage.setItem('currentprocessor', currentProcessor.loginId);
        }

        let currentLoanOfficer = loanData.contacts.find(contact => contact.contactType === 'LOAN_OFFICER');
        sessionStorage.setItem('lolar', currentLoanOfficer?.loginId);

        let currentUnderwriter = loanData.contacts.find(contact => contact.contactType === 'UNDERWRITER');

        let letterData = {
            loanBorrower: loanData.applications[0].borrower.fullName,
            loanNumber: loanData.loanNumber,
            loanInterestRate: `${loanData.requestedInterestRatePercent} %`,
            emails: [currentProcessor?.email, currentLoanOfficer?.email, currentUnderwriter?.email].filter(email => email),
            loanUnderwriter: currentUnderwriter?.contactName,
            loanPropertyAddress: `${loanData.property?.streetAddress} ${loanData.property?.city}, ${loanData.property?.state} ${loanData.property?.postalCode}`
        }

        sessionStorage.setItem('letterdata', JSON.stringify(letterData));
    },
    stateSelectsAbbr: [
        'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI',
        'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY',
    ],
    verificationBorrowerFields: [
        { borrowerField: 'firstName', borrowerType: 'borrower', fieldId: '4000' },
        { borrowerField: 'firstName', borrowerType: 'coborrower', fieldId: '4004' },
        { borrowerField: 'lastName', borrowerType: 'borrower', fieldId: '4002' },
        { borrowerField: 'lastName', borrowerType: 'coborrower', fieldId: '4006' },
        { borrowerField: 'email', borrowerType: 'borrower', fieldId: '1240' },
        { borrowerField: 'email', borrowerType: 'coborrower', fieldId: '1268' },
        { borrowerField: 'ssn', borrowerType: 'borrower', fieldId: '65' },
        { borrowerField: 'ssn', borrowerType: 'coborrower', fieldId: '97' },
        { borrowerField: 'birthDate', borrowerType: 'borrower', fieldId: '1402' },
        { borrowerField: 'birthDate', borrowerType: 'coborrower', fieldId: '1403' },
        { borrowerField: 'mobilePhone', borrowerType: 'borrower', fieldId: '1490' },
        { borrowerField: 'mobilePhone', borrowerType: 'coborrower', fieldId: '1480' },
        { borrowerField: 'phoneNumber', borrowerType: 'borrower', fieldId: '66' },
        { borrowerField: 'phoneNumber', borrowerType: 'coborrower', fieldId: '98' },
        { borrowerField: 'addressLine1', borrowerType: 'borrower', fieldId: 'FR0126' },
        { borrowerField: 'addressLine1', borrowerType: 'coborrower', fieldId: 'FR0226' },
        { borrowerField: 'addressUnitType', borrowerType: 'borrower', fieldId: 'FR0125' },
        { borrowerField: 'addressUnitType', borrowerType: 'coborrower', fieldId: 'FR0225' },
        { borrowerField: 'addressUnitNumber', borrowerType: 'borrower', fieldId: 'FR0127' },
        { borrowerField: 'addressUnitNumber', borrowerType: 'coborrower', fieldId: 'FR0227' },
        { borrowerField: 'addressCity', borrowerType: 'borrower', fieldId: 'FR0106' },
        { borrowerField: 'addressCity', borrowerType: 'coborrower', fieldId: 'FR0206' },
        { borrowerField: 'addressState', borrowerType: 'borrower', fieldId: 'FR0107' },
        { borrowerField: 'addressState', borrowerType: 'coborrower', fieldId: 'FR0207' },
        { borrowerField: 'addressPostalCode', borrowerType: 'borrower', fieldId: 'FR0108' },
        { borrowerField: 'addressPostalCode', borrowerType: 'coborrower', fieldId: 'FR0208' },
        { borrowerField: 'addressCountry', borrowerType: 'borrower', fieldId: 'FR0130' },
        { borrowerField: 'addressCountry', borrowerType: 'coborrower', fieldId: 'FR0230' }
    ]
}
